import { fetchProductDetail } from '@/jsUtils/api/products';
import { loadCustomComponent } from '@/Painting/product/customLoader';
import DefaultTemplateRenderer from '@/Painting/product/components/DefaultTemplateRenderer.vue';
import i18n from '@/lang';
export default {
  name: 'ProductDynamic',
  components: {
    DefaultTemplateRenderer
  },
  data() {
    return {
      loading: true,
      error: null,
      retryable: false,
      currentComponent: null,
      componentProps: {},
      productMeta: null
    };
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    currentLocale() {
      return i18n.global.locale.value;
    },
    loadingText() {
      return this.currentLocale === 'zh' ? '加载中…' : 'Loading…';
    },
    retryText() {
      return this.currentLocale === 'zh' ? '重试' : 'Retry';
    },
    notFoundText() {
      return this.currentLocale === 'zh' ? '未找到产品信息' : 'Product not found';
    },
    offlineText() {
      return this.currentLocale === 'zh' ? '该产品已下架' : 'This product is offline';
    },
    canRetry() {
      return this.retryable;
    }
  },
  watch: {
    slug() {
      this.loadProduct();
    },
    currentLocale() {
      this.loadProduct();
    }
  },
  created() {
    this.loadProduct();
  },
  methods: {
    async loadProduct() {
      if (!this.slug) {
        this.error = this.notFoundText;
        this.loading = false;
        return;
      }
      this.loading = true;
      this.error = null;
      this.retryable = false;
      this.currentComponent = null;
      this.componentProps = {};
      try {
        const data = await fetchProductDetail(this.slug, this.currentLocale);
        this.productMeta = data;
        if (!data || data.status && data.status !== 'published') {
          this.error = this.offlineText;
          this.retryable = false;
          return;
        }
        if (data.templateType === 'default' && data.defaultTemplate) {
          this.currentComponent = DefaultTemplateRenderer;
          this.componentProps = {
            template: data.defaultTemplate,
            productMeta: data
          };
          return;
        }
        if (data.templateType === 'custom') {
          const componentKey = data.customComponent || data.slug;
          const component = loadCustomComponent(componentKey);
          if (!component) {
            this.error = this.notFoundText;
            this.retryable = false;
            return;
          }
          const isRemote = componentKey && componentKey.toString().startsWith('remote:');
          this.currentComponent = component;
          this.componentProps = isRemote ? {
            payload: data.customData || {},
            productMeta: data
          } : {};
          return;
        }
        this.error = this.notFoundText;
      } catch (err) {
        console.error('[product_dynamic] loadProduct error', err);
        if (err && err.message === 'PRODUCT_NOT_FOUND') {
          this.error = this.notFoundText;
          this.retryable = false;
        } else {
          this.error = this.currentLocale === 'zh' ? '加载失败，请稍后重试' : 'Failed to load product';
          this.retryable = true;
        }
      } finally {
        this.loading = false;
      }
    }
  }
};